export const GET_CONSENT_MANAGEMENT_FILTERS_SUCCESS = '[CONSENT_MANAGEMENT][FILTERS] get consent management filters';
export const GET_CONSENT_MANAGEMENT_DATA_SUCCESS = '[CONSENT_MANAGEMENT][GET] get data success';
export const SET_CONSENT_MANAGEMENT_PARAMS_SUCCESS = '[CONSENT_MANAGEMENT][SET] set params success';
export const SET_CONSENT_MANAGEMENT_POPULATE_PAYLOAD_SUCCESS = '[CONSENT_MANAGEMENT] set Populate Payload success';
export const HYDRATE_CONSENT_MANAGEMENT_PARAMS = '[CONSENT_MANAGEMENT][HYDRATE] hydrate params';
export const GET_CONSENT_MANAGEMENT_BANNER_SUCCESS = '[CONSENT_MANAGEMENT][BANNER] get banner success';
export const GET_CONSENT_MANAGEMENT_TAB_DATA_SUCCESS = '[CONSENT_MANAGEMENT][TAB] get tab data success';


export const CLEAR_FILTER = 'clear consent management filter';
export const ON_CHANGE = 'on consent management change';


export const SHOW_FILTER_MODAL = '[CONSENT_MANAGEMENT][FILTERS] toggle Modal';

export const GET_CONSENT_MANAGEMENT_DATA_PENDING = '[CONSENT_MANAGEMENT][GET] get data pending';

